module.exports = __webpack_public_path__ + "img/introduce-icon3.63067e42.svg";